export interface ModeOption {
  id: string;
  label: string;
}

const MYSELF_OPTION: ModeOption = {
  id: 'myself',
  label: 'One child',
};

const MYSELF_AND_OTHERS_OPTION: ModeOption = {
  id: 'myselfAndOthers',
  label: 'Booking for myself & others',
};

const OTHERS_OPTION: ModeOption = {
  id: 'others',
  label: 'Multiple children',
};

const SAME_DAY_OPTION = {
  id: 'sameDay',
  label: 'On the same day',
};

const MULTIPLE_DAYS_OPTION = {
  id: 'multipleDays',
  label: 'On multiple days',
};

const INSURANCE_PAYMENT_METHOD_OPTIONS: ModeOption[] = [
  {
    id: 'cash_credit',
    label: 'Cash/Credit',
  },
  {
    id: 'in_house_insurance',
    label: 'In-house Insurance',
  },
  {
    id: 'financing',
    label: 'Financing',
  },
];

export {
  MYSELF_OPTION,
  MYSELF_AND_OTHERS_OPTION,
  OTHERS_OPTION,
  SAME_DAY_OPTION,
  MULTIPLE_DAYS_OPTION,
  INSURANCE_PAYMENT_METHOD_OPTIONS,
};
